import { useFormikContext } from "formik";
import React, { useEffect } from "react";

const CaptureSetFieldValue = ({setExternalSetFieldValue}) => {
    const {setFieldValue} = useFormikContext();

    useEffect(() => {
        setExternalSetFieldValue(() => setFieldValue);
    }, [setFieldValue, setExternalSetFieldValue]);

    return null;
}

export default CaptureSetFieldValue;